<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectDrawForm"
        >
          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectDrawForm.projectItem"
                placeholder="请选择工程项目名称"
                width="200"
                @change="chooseProjectItem"
                value-key="id"
              >
                <el-option
                  v-for="item in projectItems"
                  :key="item.id"
                  :label="item.name"
                  :value='item'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="关联服务商"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectDrawForm.agentId"
                placeholder="请选择关联服务商"
                disabled
                width="200"
              >
                <el-option
                  v-for="item in agentIds"
                  :key="item.id"
                  :label="item.company"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label='服务抽成配置'>
            <div
              v-for="(item,index) in tableData1"
              :key="index"
            >
              <el-table
                :data="item"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  prop="yyqd"
                  label="预约渠道"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.clientType"
                      placeholder="请选择服务类目名称"
                      disabled
                      width="300"
                    >
                      <el-option
                        v-for="item in clientTypes"
                        :key="item.value"
                        :label="item.label"
                        :value='item.value'
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="area"
                  min-width="250"
                  label="服务区域"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input
                        v-model='scope.row.area'
                        disabled
                      >
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="projectList"
                  align="center"
                  label="字段名称"
                  min-width="900"
                >
                  <template slot-scope="scope">
                    <div
                      v-for="(i,idx) in tableData1[index]"
                      v-bind:key='idx'
                    >
                      <el-table
                        :data="tableData1[index][idx].projectTakePercentageList"
                        :span-method="inSpanMethod"
                        border
                        style="width: 100%; margin-top: 20px"
                      >
                        <el-table-column
                          prop="name"
                          label="工程阶段名称"
                          width="120"
                        >
                          <template slot-scope="scope">
                            {{scope.row.name}}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="type"
                          label="抽成类型"
                          min-width="150"
                        >
                          <template slot-scope="scope">
                            <el-select
                              v-model="scope.row.type"
                              placeholder="请选择抽成类型"
                              width="200"
                            >
                              <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value='item.value'
                              ></el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="platform"
                          min-width="150"
                          label="平台抽成"
                        >
                          <template slot-scope="scope">
                            <el-input
                              type='number'
                              min="0"
                              v-model='scope.row.platform'
                            >
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="engineer"
                          min-width="150"
                          label="服务工程师"
                        >
                          <template slot-scope="scope">
                            <el-input
                              type='number'
                              min="0"
                              v-model='scope.row.engineer'
                            >
                            </el-input>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >确定新增</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath,  } from "@/util/util";
import {
  findProject,
  findAllSuperiorDepartment,
  findEngineeringProjectAll,
  findEngineeringDynamicId,
  addEngineeringPercentage,
  findProvince,
  findCitys,
  findAreas,
  findDataSourceFields,
  findDataSourceAll,
} from "@/api/work/projectDraw";

export default {
  data() {
    return {
      projectItems: [],
      categoryTypes: DIC.SERVICEITEM_YYTYPE,
      qd: [1, 2],
      isPas: false,
      types: DIC.WORK_TAKE_PERCENTAGE_TYPE,
      promoterTypes: DIC.SERVICEDRAW_PROMOTER_TYPE,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      areas: [],
      citys: [],
      provinces: [],
      projectDrawForm: {},
      projectName: ["管道安装", "设备调试"],
      list: {
        fst: [],
        sed: []
      },
      secondId: "设备调试",
      fstId: "管道安装",
      tableData1: {}
    };
  },
  created() {
    findEngineeringProjectAll().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    findAllSuperiorDepartment().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);

      this.agentIds = data;
      this.agentIds.push({ company: "社区", id: "0" });
    });
    findProject().then(res => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
    findProvince().then(res => {
      // let data = JSON.parse(res.data);
      console.log(res);
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
  },
  methods: {
    chooseProjectItem(e) {
      console.log(e);
      this.projectDrawForm.agentId = e.agentId;
      findEngineeringDynamicId(e.id).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        let list = [];
        let obj = {};
        for (let i = 0; i < data.takePercentageChannelList.length; i++) {
          console.log(data.takePercentageChannelList[i]);
          list[i] = [];
          let dtobj = {};
          dtobj.clientType = data.takePercentageChannelList[i].clientType;
          dtobj.id = data.takePercentageChannelList[i].id;
          dtobj.projectTakePercentageList =
            data.takePercentageChannelList[i].projectTakePercentageList;
          dtobj.area =
            (data.takePercentageChannelList[i].provinceName == null
              ? ""
              : data.takePercentageChannelList[i].provinceName) +
            (data.takePercentageChannelList[i].cityName == null
              ? ""
              : data.takePercentageChannelList[i].cityName) +
            (data.takePercentageChannelList[i].areaName == null
              ? ""
              : data.takePercentageChannelList[i].areaName);
          // data.takePercentageChannelList[i].provinceName +
          // data.takePercentageChannelList[i].cityName +
          // data.takePercentageChannelList[i].areaName;
          list[i].push(dtobj);
          obj[i] = list[i];
        }
        console.log(list);
        console.log(obj);

        this.tableData1 = obj;
      });
    },
    chooseProvince(e) {
      console.log(e);
      findCitys(e.id).then(res => {
        this.citys = res.data;
        this.currentCity = "";
        console.log(this);
        this.currentArea = "";
      });
    },
    chooseCity(e) {
      findAreas(e.id).then(res => {
        this.areas = res.data;
        this.currentArea = "";
        console.log(this);
      });
    },
    chooseArea() {
      console.log(this);
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error"
        });
        return;
      }
      let list = e.channel.split(",");
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;

        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(list);
      console.log(obj);
      this.tableData1 = obj;
    },
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e;
      findProject(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
      });
    },
    submit() {
      let item = {
        close: true,
        label: "新增服务抽成",
        value: "/work/projectDraw/add"
      };
      console.log(this.tableData1);
      let takePercentageChannelList = [];
      let obj = {};
      obj.id = this.projectDrawForm.projectItem.id;
      for (let item in this.tableData1) {
        console.log(this.tableData1[item][0]);
        takePercentageChannelList.push(this.tableData1[item][0]);
        let dtobj = {};
        // dtobj.id = list.push(this.tableData1[item][0]);
        console.log(dtobj);
      }
      obj.takePercentageChannelList = takePercentageChannelList;
      console.log(obj);
      let params = obj;
      addEngineeringPercentage(params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectDraw",
              label: "工程抽成管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      console.log(index, row);
      // this.tableData.splice(index, 1);
      console.log(this.tableData1[row].length);
      if (this.tableData1[row].length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单不能为空",
          type: "error"
        });
      } else {
        this.tableData1[row].splice(index, 1);
      }
    },
    handle1SteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);
      var isFst;
      if (row.id != "undefined" && row.id != null) {
        isFst = row.id;
      } else {
        isFst = row;
      }
      console.log(this.tableDate, row);
      if (isFst == "设备调试") {
        this.list1["sed"].splice(index, 1);
      } else {
        this.list1["fst"].splice(index, 1);
      }
    },
    handleAddRows(index, row) {
      console.log(this.tableData1[row][0]);
      console.log(index, row);
      let list = {
        targetType: "CONFIG"
      };
      // list.push(this.tableData1[row][0]);
      this.tableData1[row].push(list);
    },
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 2) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 11) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    inSpanMethod({ row, column, rowIndex, columnIndex }) {}
  }
};
</script>

<style>
</style>